
import { supabase } from '@/integrations/supabase/client';

interface OpenAIMessage {
  role: 'system' | 'user' | 'assistant';
  content: string;
}

interface OpenAIResponse {
  content: string;
  usage?: any;
  model?: string;
  error?: string;
}

interface ChatCompletionRequest {
  messages: OpenAIMessage[];
  isGenZMode?: boolean;
  model?: string;
  temperature?: number;
  max_tokens?: number;
}

export const hasOpenAIApiKey = (): boolean => {
  return true; // Edge function sempre tem acesso via secrets
};

export const createChatCompletion = async (
  messages: OpenAIMessage[],
  isGenZMode: boolean = false,
  options: {
    model?: string;
    temperature?: number;
    max_tokens?: number;
  } = {}
): Promise<OpenAIResponse> => {
  try {
    // Verificar se usuário está autenticado
    const { data: { session } } = await supabase.auth.getSession();
    if (!session) {
      return {
        content: '',
        error: 'Usuário não autenticado'
      };
    }

    const payload: ChatCompletionRequest = {
      messages,
      isGenZMode,
      model: options.model || 'gpt-4o-mini',
      temperature: options.temperature || 0.7,
      max_tokens: options.max_tokens
    };

    const { data, error } = await supabase.functions.invoke('openai-chat-completion', {
      body: payload,
      headers: {
        'Authorization': `Bearer ${session.access_token}`,
      }
    });

    if (error) {
      console.error('Supabase function error:', error);
      return {
        content: '',
        error: error.message || 'Erro ao chamar função OpenAI'
      };
    }

    if (data.error) {
      return {
        content: '',
        error: data.message || data.error
      };
    }

    return {
      content: data.content,
      usage: data.usage,
      model: data.model
    };
  } catch (error) {
    console.error('OpenAI service error:', error);
    return {
      content: '',
      error: error instanceof Error ? error.message : 'Erro desconhecido'
    };
  }
};

// Função para monitorar uso da API - retorna dados mock
export const getApiUsage = async (): Promise<any[]> => {
  try {
    console.log('📊 Buscando uso da API (mock data)');
    
    // Return mock data since table doesn't exist
    const mockUsage = [
      {
        id: 'usage-1',
        user_id: 'mock-user',
        tokens_used: 150,
        cost: 0.003,
        created_at: new Date().toISOString()
      }
    ];
    
    console.log('ℹ️ Retornando dados de exemplo para uso da API');
    return mockUsage;
  } catch (error) {
    console.error('Erro ao buscar uso da API:', error);
    return [];
  }
};

// Função para buscar logs da API - retorna dados mock
export const getApiLogs = async (): Promise<any[]> => {
  try {
    console.log('📋 Buscando logs da API (mock data)');
    
    // Return mock data since table doesn't exist
    const mockLogs = [
      {
        id: 'log-1',
        endpoint: '/openai/chat',
        status: 200,
        response_time: 1250,
        created_at: new Date().toISOString()
      }
    ];
    
    console.log('ℹ️ Retornando dados de exemplo para logs da API');
    return mockLogs;
  } catch (error) {
    console.error('Erro ao buscar logs da API:', error);
    return [];
  }
};
